module.exports = __webpack_public_path__ + "static/media/ios-share.95553992.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ios-share.svg
// module id = 671
// module chunks = 0